import { realResizeEvent } from "../utilities/globalUtilities";
import { mobileMenuButtonToggle } from "./menuUtils";
import { initMenu } from "./menu";
const mqueryRespond = window.mqRespond;

var debounce = require("lodash/debounce");

var $cache = {
    mainMenu: $(".main-menu"),
    window: $(window)
};

let windowWidth = $cache.window.width();

/**
 * Delivery method widget option change
 */
const deliveryOptions = () => {
    const $modalMobileFooter = $("#coverage-area-modal .modal-footer");

    $(".delivery-wrapper .delivery-option").off("click").on("click", e => {
        e.preventDefault();
        const selectedMethod = $(e.target).closest(".delivery-option").data("method");
        const $deliveryWrapper = $(".delivery-wrapper");
        const $openModalMobileSelected = $(".open-modal-mobile[data-method='"+selectedMethod+"']");
        const $deliveryMethodsButton = $(".delivery-methods-button");


        $(".option-selected", $deliveryWrapper).removeClass("option-selected");
        $deliveryWrapper.attr("data-method", selectedMethod);
        $(".delivery-option[data-method='"+selectedMethod+"']", $deliveryWrapper).addClass("option-selected");
        $(".options-detail[data-method='"+selectedMethod+"']", $deliveryWrapper).addClass("option-selected");
        $modalMobileFooter.hide();

        if ($(e.target).closest("header") && $(e.target).closest("header").length > 0) {
            if (selectedMethod == "fast") {
                if ($openModalMobileSelected.length > 0) {
                    $openModalMobileSelected.trigger("click");
                }

                if ($deliveryMethodsButton.length > 0 && !$deliveryMethodsButton.hasClass("collapsed")) {
                    $deliveryMethodsButton.trigger("click");
                }
                setTimeout(function () { // restores main option after click on fast delivery
                    $("header .delivery-wrapper .option-selected").removeClass("option-selected");
                    $("header .delivery-wrapper .delivery-option[data-method='"+$("#collapseDelivery").data("method-selected")+"'], header .delivery-wrapper .options-detail[data-method='"+$("#collapseDelivery").data("method-selected")+"']").addClass("option-selected");
                }, 300);
            } else {
                const homeTypeWidget = $deliveryMethodsButton.data("home-type");
                const homeValueWidget = $deliveryMethodsButton.data("home-value");
                const storeTypeWidget = $deliveryMethodsButton.data("store-type");
                const storeValueWidget = $deliveryMethodsButton.data("store-value");

                const $elemType = $(".delivery-wrapper .delivery-options .options-selector .options-detail .option-title .option-delivery-type");
                const $elemValue = $(".delivery-wrapper .delivery-options .options-selector .options-detail .option-value");

                if (selectedMethod == "home") {
                    $elemType.text(homeTypeWidget);
                    $elemValue.text(homeValueWidget);
                } else {
                    $elemType.text(storeTypeWidget);
                    $elemValue.text(storeValueWidget);
                }
                $modalMobileFooter.show();
            }
        } else {
            if (selectedMethod != "fast") {
                $modalMobileFooter.show();
            }
        }
    });

    $("header .delivery-wrapper .options-details").on("click", function () {
        if ($modalMobileFooter.length > 0 && !$modalMobileFooter.hasClass("collapsed")) {
            $modalMobileFooter.trigger("click");
        }
    });
};

function handleOutsideWidgetClick() {
    const $deliveryWrapperHeader = $("header .delivery-wrapper");
    const $deliveryWrapper = $deliveryWrapperHeader.find(".position-relative");
    const $deliveryTrigger = $deliveryWrapper.find(".delivery-methods-button");

    if ((mqueryRespond.status.desktop || mqueryRespond.status.desktopLarge) && $deliveryWrapperHeader.length > 0) {
        $("body").off("click.outsideWidget").on("click.outsideWidget", e => {
            const awaitingTrigger = $("body").hasClass("awaiting-trigger");

            if (!$deliveryWrapper.has(e.target).length && !awaitingTrigger && $deliveryTrigger.attr("aria-expanded") == "true") {
                $("body").addClass("awaiting-trigger");
                $deliveryTrigger.trigger("click");
                $("body").removeClass("awaiting-trigger");
            }
        });
    }
}

/**
 * Load Navigation and init menu events
 * Desktop breakpoint - when page loads
 * Mobile/Tablet - on click event
 */
const loadNavigation = () => {
    const isMobileOrTablet = window.mqRespond.status.mobile || window.mqRespond.status.tablet;
    const $navWrapper = $(".navbar-expand-md");
    const $mainNavigationWrapper = $(".main-navigation-wrapper");
    const urlMobile = $navWrapper.attr("data-url-mobile");
    const $navWrapperDesktop = $(".menu-group");

    // Remove Mobile navigation from DOM
    if (!isMobileOrTablet && $(".mobile-menu-group").length && $(".coverage-form-wrapper").length) {
        $(".mobile-menu-group").remove();
        $(".coverage-form-wrapper").remove();
    }

    // Mobile navigation
    $(".navbar-toggler").off("click").on("click", e => {
        e.preventDefault();

        // if Navigation is already in DOM or is expanded
        if ($mainNavigationWrapper.hasClass("active-menu") || $(".mobile-menu-group").length) {
            mobileMenuButtonToggle();
            handleMenuAfterToggle();
            // scroll to top
            const element = document.getElementsByClassName("postal-code-input-wrapper");
            element.length ? element[0].scrollIntoView() : null;

            return;
        }

        // if Navigation is not in DOM
        if (isMobileOrTablet && !$(".mobile-menu-group").length) {
            $.spinner().start();

            $.ajax({
                url: urlMobile,
                method: "GET",
                dataType: "html",
                success: data => {
                    $navWrapperDesktop.after(data);

                    mobileMenuButtonToggle();
                    handleMenuAfterToggle();

                    $cache.mainMenu.attr("aria-hidden", "false");
                    $cache.mainMenu.siblings().attr("aria-hidden", "true");
                    $(".main-menu .nav.navbar-nav .nav-link").first().focus();

                    // init menu functionality
                    initMenu();

                    // scroll to top
                    const element = document.getElementsByClassName("postal-code-input-wrapper");
                    element.length ? element[0].scrollIntoView() : null;

                    $.spinner().stop();
                },
                error: () => {
                    $.spinner().stop();
                }
            });
        }
    });
};

/**
 * After main menu is toggled, manipulate DOM
 */
const handleMenuAfterToggle = function () {
    const $deliveryMobileWrapper = $(".navigation-delivery-mobile");

    // The behavior on the home page doesn't need to be changed
    if ($deliveryMobileWrapper.hasClass("navigation-delivery-mobile-home")) {
        return;
    }

    // On other pages other than home page
    // If mobile navigation opened, show the delivery selector, or hide if closed
    $deliveryMobileWrapper.toggleClass("d-flex d-none d-sm-flex d-md-none");
};

/**
 * Init events for Navigation
 */
const initEvents = () => {
    initMenu();
    loadNavigation();
    deliveryOptions();
    handleOutsideWidgetClick();

    $(window).on("resize", debounce(() => {
        if (!realResizeEvent(windowWidth)) { return; }

        windowWidth = $cache.window.width();
        loadNavigation();

        if ($(".navigation-open").length) {
            mobileMenuButtonToggle(true);
        }
    }, 10));
};

export { initEvents };
